import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = ({ logo }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav className={`sticky top-0 z-50 transition-all duration-300 ${
      isScrolled ? 'glass-nav shadow-lg py-2' : 'bg-transparent py-4'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center">
        {/* Desktop Navigation */}
        <div className="hidden md:flex space-x-1 mx-auto bg-white/10 backdrop-blur-sm rounded-full px-2 py-1 border border-white/20">
          <Link to="/" className="text-brand-900 hover:text-brand-600 hover:bg-white/20 px-4 py-2 rounded-full font-medium text-sm uppercase tracking-wider transition-all duration-300 ease-in-out">Home</Link>
          {location.pathname === '/' && (
            <>
              <a href="#about" className="text-brand-900 hover:text-brand-600 hover:bg-white/20 px-4 py-2 rounded-full font-medium text-sm uppercase tracking-wider transition-all duration-300 ease-in-out">About Us</a>
              <a href="#services" className="text-brand-900 hover:text-brand-600 hover:bg-white/20 px-4 py-2 rounded-full font-medium text-sm uppercase tracking-wider transition-all duration-300 ease-in-out">Services</a>
              <a href="#subsidiaries" className="text-brand-900 hover:text-brand-600 hover:bg-white/20 px-4 py-2 rounded-full font-medium text-sm uppercase tracking-wider transition-all duration-300 ease-in-out">Subsidiaries</a>
              <a href="#contact" className="text-brand-900 hover:text-brand-600 hover:bg-white/20 px-4 py-2 rounded-full font-medium text-sm uppercase tracking-wider transition-all duration-300 ease-in-out">Contact Us</a>
            </>
          )}
          <Link to="/news" className="text-brand-900 hover:text-brand-600 hover:bg-white/20 px-4 py-2 rounded-full font-medium text-sm uppercase tracking-wider transition-all duration-300 ease-in-out">News</Link>
        </div>

        {/* Mobile menu button */}
        <div className="md:hidden ml-auto">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="text-brand-900 hover:text-brand-600 focus:outline-none"
            aria-label="Toggle menu"
          >
            <div className="relative w-6 h-6">
              <span 
                className={`absolute block w-6 h-0.5 bg-current transform transition duration-300 ease-in-out ${
                  isMenuOpen ? 'rotate-45 translate-y-1.5' : 'translate-y-0'
                }`} 
                style={{ top: '35%' }}
              ></span>
              <span 
                className={`absolute block w-6 h-0.5 bg-current transform transition duration-300 ease-in-out ${
                  isMenuOpen ? 'opacity-0' : 'opacity-100'
                }`} 
                style={{ top: '50%' }}
              ></span>
              <span 
                className={`absolute block w-6 h-0.5 bg-current transform transition duration-300 ease-in-out ${
                  isMenuOpen ? '-rotate-45 -translate-y-1.5' : 'translate-y-0'
                }`} 
                style={{ top: '65%' }}
              ></span>
            </div>
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div 
        className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
          isMenuOpen ? 'max-h-96 opacity-100 mt-4 pb-4 glass-nav' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="flex flex-col space-y-3 px-4">
          <Link to="/" onClick={() => setIsMenuOpen(false)} className="text-brand-900 hover:text-brand-600 font-medium py-2 border-b border-neutral-100">Home</Link>
          {location.pathname === '/' && (
            <>
              <a href="#about" onClick={() => setIsMenuOpen(false)} className="text-brand-900 hover:text-brand-600 font-medium py-2 border-b border-neutral-100">About Us</a>
              <a href="#services" onClick={() => setIsMenuOpen(false)} className="text-brand-900 hover:text-brand-600 font-medium py-2 border-b border-neutral-100">Services</a>
              <a href="#subsidiaries" onClick={() => setIsMenuOpen(false)} className="text-brand-900 hover:text-brand-600 font-medium py-2 border-b border-neutral-100">Subsidiaries</a>
              <a href="#contact" onClick={() => setIsMenuOpen(false)} className="text-brand-900 hover:text-brand-600 font-medium py-2 border-b border-neutral-100">Contact Us</a>
            </>
          )}
          <Link to="/news" onClick={() => setIsMenuOpen(false)} className="text-brand-900 hover:text-brand-600 font-medium py-2 border-b border-neutral-100">News</Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;